<template>
  <div ref="container" class="fachords_app">

    <div class="appPanel rounded" :style="giancaRemoveBackground === true ? { backgroundColor: 'white!important' } : {}">

      <!-- loader lessons -->
      <!--    <div v-if="1===2">
            <div class="centered">
              <img src="/static/fachords3/tools/media/loading.gif" alt="loading app">
              <p><i>Loading your interactive tool</i></p>
            </div>
          </div>
    -->

      <!-- lessons loaded, si parte! -->
      <div>
        <button class="appButton helpButton rounded" @click="showInfo= !showInfo">
          <img src="/static/fachords3/icons/svg/269-info.svg" alt="show info" class="appIcon" v-show="showInfo===false">
          <img src="/static/fachords3/icons/svg/270-cancel-circle.svg" alt="exit info" class="appIcon" v-show="showInfo===true">
        </button>

        <!-- info panel -->
        <div v-show="showInfo===true">
          <h3 class="appTitle">About This tool</h3>

          <p>This interactive tool has been created by <a href="https://www.fachords.com" target="_blank">FaChords Guitar</a>, to help guitar students improve their skills in an intuitive way.</p>

          <p>Please reach out to us if you want to use this tool <strong>on your website</strong> (for free).</p>

          <p>For any request, you can <a href="https://www.fachords.com" target="_blank">contact us here</a>.

          <p><a @click="showInfo=false" style="cursor: pointer">Back to the tool</a></p>
        </div>

        <!-- tool -->
        <div>

          <h3 class="appTitle"></h3>

          <div class="hud">


            <button class="appControl appButton  rounded" title="Play sequence" @click="togglePlay()">

              <img src="/static/fachords3/icons/svg/286-pause2.svg" alt="Pause playback" class="appIcon" v-show="isPlay===true && soundLoaded===true">
              <img src="/static/fachords3/icons/svg/285-play3.svg" alt="Start playback" class="appIcon" v-show="isPlay===false && soundLoaded===true">
              <img src="/static/fachords3/tools/media/wheel.gif" alt="loading sounds" class="appIcon" v-show="soundLoaded===false">

            </button>


            <button class="btn btn-default rounded" title="Show MIDI codes" @click="showMIDI()" :class="{'btn-primary':mode===0}">
              Show MIDI
            </button>
            <button class="btn btn-default rounded" title="Show frequencies" @click="showFrequencies()" :class="{'btn-primary':mode===1}">
              Show Frequencies
            </button>
            <button class="btn btn-default rounded" title="Show note names" @click="showNoteNames" :class="{'btn-primary':mode===2}">
              Show Notes
            </button>
            <button class="btn btn-default rounded" title="Show note names" @click="showAllFrets">
              Show All Frets
            </button>
            <button class="btn btn-default rounded" title="Show note names" @click="clearFretboard">
              Clear Fretboard
            </button>

          </div>

          <FretboardContainer :guitar="guitar"
                              :showTones="true"
                              @fretClick="handleFretClick"/>
        </div>


      </div>
    </div>


  </div>

</template>


<script>

import FretboardContainer from "@shared/components/fretboard/FretboardContainer";
import appStore from "./appStore"
import baseStore from "@shared/stores/baseStore";


export default {
  components: {FretboardContainer},

  data() {
    return {
      showInfo: false, giancaRemoveBackground: false, showTones: false, isPlay: false, selectedStepId: 0, debounceBpmTimer: null,


      mode: 0

    };
  },


  created() {
    //abilita modifiche sequenza da utente
    baseStore.commit('setEnableUserInput', {'value': true});
  },

  watch: {},

  computed: {

    guitar() {
      return baseStore.state.guitar;
    },

    soundLoaded() {
      return baseStore.getters.soundLoaded;
    },

    lesson() {
      return appStore.state.activeLesson;
    },

    lessonStage() {
      return appStore.getters.activeLessonStage;
    },

    bpm() {
      return baseStore.state.soundTrack.bpm;
    },


    localBpm: {
      get() {
        return this.bpm
      }, set(value) {
        if (this.debounceBpmTimer) clearTimeout(this.debounceBpmTimer)
        this.debounceBpmTimer = setTimeout(() => {
          baseStore.dispatch('setBpm', {'bpm': value})
        }, 500)
      },
    },

  },


  mounted() {


    window.addEventListener('keydown', this.handleKeyPress);
    this.showMIDI();


  },


  methods: {


    handleFretClick(params) {
      baseStore.commit('toggleFret', params)
    },


    togglePlay() {
      this.isPlay = !this.isPlay;

      if (this.isPlay === true) {
        baseStore.commit('startPlayback')
      } else {
        baseStore.commit('stopPlayback')
      }
    },


    beforeDestroy() {

      window.removeEventListener('keydown', this.handleKeyPress);
    },


    showMIDI() {
      appStore.commit('showMIDI')
      this.mode = 0;
    },

    showFrequencies() {
      appStore.commit('showFrequencies')
      this.mode = 1;
    },

    showNoteNames() {
      appStore.commit('showNoteNames')
      this.mode = 2
    },


    clearFretboard() {
      appStore.commit('clearFretboard')
    },

    showAllFrets() {
      appStore.commit('showAllFrets')
    }


  }
}

</script>

<style>

.note {
  font-size: 0.9em !important;
}

.appTitle {
  color: #222222;
}

.appPanel {
  background-color: #f2f2f3;

  padding: 1em;
  overflow: auto;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: content-box;
  box-sizing: border-box;
  height: 100%;
}

.fachords_app {
  background-color: #FFFFFF;
}

@media only screen and (max-width: 600px) {
  .fachords_app {
    height: 1100px;
  }

  .appControl {
    margin-bottom: 5px;
  }
}

@media only screen and (min-width: 600px) {
  .fachords_app {
    height: 400px;
  }
}

.hud {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.appSelectList {
  height: 35px; /* Adjust the height as needed */
  margin-right: 1px;
  padding-left: 5px;
  min-width: 150px;
  background-color: white;
  width: 40%;
}

.bpmControl {
  width: 70px;
  text-align: center;
  margin-left: 1px;
  margin-right: 1px;
}

.appInput {
  height: 35px;
  margin-left: 1px;
  margin-right: 1px;

}

.appButton {
  height: 35px; /* Adjust the height as needed */
  padding: 0 15px;
  color: #222;
  background-color: #fcfcfc;
  border: 1px solid #222222;

  cursor: pointer;
  margin-left: 1px;
  margin-right: 1px;
  width: 50px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
}

.appIcon {
  width: 24px; /* Adjust the width and height to fit your icon */
  height: 24px;
  fill: #fff; /* Fill color for the SVG icon */

}

.appButton:hover {
  background-color: #cecece
}


.fret {
  position: absolute;
  height: 35px;
  float: left;
  cursor: pointer;
  text-align: center;
  z-index: 5;

}

.fretIsPlaying {
  background-color: white !important;
}


/*color gradi 0-11*/
.color_degree_0 {
  background-color: #F7E721;
  color: #222222 !important;
}

.color_degree_1 {
  background-color: #C6DF31;
  color: #FFFFFF;
}

.color_degree_2 {
  background-color: #6BBE52;
  color: #FFFFFF;
}

.color_degree_3 {
  background-color: #00AE84;
  color: #FFFFFF;
}

.color_degree_4 {
  background-color: #00AECE;
  color: #FFFFFF;
}

.color_degree_5 {
  background-color: #0086CE;
  color: #FFFFFF;
}

.color_degree_6 {
  background-color: #4261AD;
  color: #FFFFFF;
}

.color_degree_7 {
  background-color: #8C499C;
  color: #FFFFFF;
}

.color_degree_8 {
  background-color: #E7288C;
  color: #FFFFFF;
}

.color_degree_9 {
  background-color: #EF4142;
  color: #FFFFFF;
}

.color_degree_10 {
  background-color: #F76929;
  color: #FFFFFF;
}

.color_degree_11 {
  background-color: #FFAE21;
  color: #FFFFFF;

}

.fretMarker {

  position: absolute;
  width: 15px !important;
  height: 15px !important;
  background-color: #a2a2a2;
  text-align: center;


  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  border-radius: 7px;

  margin-top: -5px;

  z-index: 0;


}


.fretboardWood {
  background-image: url("/static/fachords3/tools/media/maple.jpg");
  background-repeat: repeat;

}

.note {
  color: #222222;
  background-color: #FEFEFE;
  padding: 4px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;

  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  pointer-events: none;


  font-size: 18px;

  overflow: hidden;
  white-space: nowrap;

  z-index: 5;

  height: 23px;
  width: 55px;
  min-width: 55px;
  box-shadow: 5px 5px 10px black;
}

.isHovering {
  background-color: yellow;
}

.about_link {
  display: block;
  margin: 0;
  margin-bottom: -5px !important;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
  color: #222;
  padding: 0px;
  font-weight: normal;
  transition: background-color 0.3s;
  line-height: 1.1;
}

.helpButton {
  position: relative;
  top: 0px;
  float: right;

}

.description {
  height: 80px;
  background-color: #fcfcfc;
  padding: 5px;
  text-align: center;
  line-height: 1.5em;
}
</style>
